'use client';
import ButtonLink from '@/components/ButtonLink';
import { usePathname } from 'next/navigation';
import Link from 'next/link';
import { useEffect, useState } from 'react';
import useWeddingDate from '@/hooks/useWeddingDate';

function Menu() {
  const [open, setOpen] = useState(false);
  const [invitation, setInvitation] = useState(null);
  const pathname = usePathname();
  const isHome = pathname === '/';

  const { wedding_date } = useWeddingDate();

  const handleOpenMenu = () => {
    setOpen(!open);
  };

  useEffect(() => {
    if (localStorage && localStorage.getItem('code')) {
      setInvitation(JSON.parse(localStorage.getItem('code')));
    }
  }, []);

  return (
    <nav className="py-2.5 px-5 fixed top-0 w-full bg-green flex justify-between items-center z-20 flex-wrap">
      <Link prefetch={true} href="/" className="text-white text-xl">
        Maty&Valen
      </Link>
      <ul
        className={`flex lg:justify-center items-center absolute z-10 top-12 ${!open ? '-left-full' : 'left-0'} lg:top-auto lg:left-auto flex-col lg:flex-row lg:relative lg:gap-x-5 xl:gap-x-10 transition-all h-screen lg:h-auto bg-green gap-y-10 px-2.5 pt-5 lg:p-0`}
      >
        <li className="text-white hover:text-gold transition-colors duration-300 text-center">
          <Link onClick={() => setOpen(false)} prefetch={true} href="/" className={pathname.length === 0 ? 'underline underline-offset-8' : ''}>
            Inicio
          </Link>
        </li>
        {invitation ? (
          <li className="border-gold border border-solid rounded-full px-2.5 py-1 text-gold hover:text-white hover:bg-gold transition-colors duration-300 text-center">
            <Link onClick={() => setOpen(false)} prefetch={true} href={'/invitacion?code=' + invitation} className={pathname.includes('invitacion') ? '!hover:text-green' : ''}>
              Mi invitación
            </Link>
          </li>
        ) : null}
        <li className="text-white hover:text-gold transition-colors duration-300 text-center">
          <Link onClick={() => setOpen(false)} prefetch={!isHome} href={isHome ? '#dress-code' : '/dress-code'} className={pathname.includes('dress-code') ? 'underline underline-offset-8' : ''}>
            Código de vestimenta
          </Link>
        </li>
        <li className="text-white hover:text-gold transition-colors duration-300 text-center">
          <Link onClick={() => setOpen(false)} prefetch={!isHome} href={isHome ? '#regalos' : '/regalos'} className={pathname.includes('regalos') ? 'underline underline-offset-8' : ''}>
            Regalos
          </Link>
        </li>
        <li className="text-white hover:text-gold transition-colors duration-300 text-center">
          <Link onClick={() => setOpen(false)} prefetch={!isHome} href={isHome ? '#songs-player' : '/songs-player'} className={pathname.includes('songs-player') ? 'underline underline-offset-8' : ''}>
            Nuestras canciones
          </Link>
        </li>
        <li className="text-white hover:text-gold transition-colors duration-300 text-center">
          <Link onClick={() => setOpen(false)} prefetch={true} href="/after-party" className={pathname.includes('after-party') ? 'underline underline-offset-8' : ''}>
            After Party
          </Link>
        </li>
        <li className="text-white hover:text-gold transition-colors duration-300 text-center">
          <Link onClick={() => setOpen(false)} prefetch={!isHome} href={isHome ? '#contacto' : '/contacto'} className={pathname.includes('contacto') ? 'underline underline-offset-8' : ''}>
            Contacto
          </Link>
        </li>
        <li>
          {wedding_date > 0 ? (
            <ButtonLink onClick={() => setOpen(false)} href={isHome ? '#confirm-assistance' : '/confirmar-asistencia'} className="w-fit font-medium !p-1.5 text-sm" target="_self">
              Confirmar asistencia
            </ButtonLink>
          ) : (
            <ButtonLink href="#" className="w-fit font-medium !p-1.5 text-sm opacity-50 cursor-not-allowed" disabled={true} target="_self">
              Confirmar asistencia
            </ButtonLink>
          )}
        </li>
      </ul>
      <button type="button" className="lg:hidden flex flex-col justify-between h-8 w-8 group border rounded p-1.5 border-gold" onClick={handleOpenMenu} aria-label="menu">
        <span className="h-[3px] w-full bg-gold rounded-sm origin-left transition-all group-hover:rotate-45"></span>
        <span className="h-[3px] w-full bg-gold rounded-sm transition-all group-hover:opacity-0"></span>
        <span className="h-[3px] w-full bg-gold rounded-sm origin-left transition-all group-hover:-rotate-45"></span>
      </button>
    </nav>
  );
}

export default Menu;
